
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const BaseUrl = process.env.REACT_APP_BASH_URL;

export const fetchModules = createAsyncThunk('modules/fetchModules', async () => {
    const token = localStorage.getItem("admin-auth-token");
    const options = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
    };
    const response = await axios.get(`${BaseUrl}/admin/modules`, { headers: options });
    return response.data;
});

export const updateVendorAccess = createAsyncThunk(
    'modules/updateVendorAccess',
    async ({ vendorId, permissions }) => {
        const token = localStorage.getItem("admin-auth-token");
        const options = {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        };
        const response = await axios.post(`${BaseUrl}/admin/vendor/access/${vendorId}`, { permissions }, { headers: options });
        return response.data;
    }
);

export const fetchVendorModules = createAsyncThunk(
    'modules/fetchVendorModules',
    async (id) => {
        const token = localStorage.getItem("admin-auth-token");
        const options = {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        };
        const response = await axios.get(`${BaseUrl}/admin/vendor/access/${id}`, { headers: options });
        return response.data;
    }
);


export const updateModulePrice = createAsyncThunk(
    'modules/updatePrice',
    async ({ cat, pricePerMonth, interval }) => {
        const token = localStorage.getItem("admin-auth-token");
        const options = {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        };
        await axios.post(`${BaseUrl}/admin/modules/set-price`, { cat, pricePerMonth, interval }, { headers: options });
        return { cat, pricePerMonth };
    }
);

export const updateModuleStatus = createAsyncThunk(
    'modules/updateModuleStatus',
    async ({ cat, status }) => {
        const token = localStorage.getItem("admin-auth-token");
        const options = {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        };
        await axios.post(`${BaseUrl}/admin/modules/isActive`, { cat, status }, { headers: options });
        return { cat, status };
    }
);



const moduleSlice = createSlice({
    name: 'modules',
    initialState: {
        modules: [],
        vendorModules: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModules.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchModules.fulfilled, (state, action) => {
                state.modules = action.payload;
                state.loading = false;
            })
            .addCase(fetchModules.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(fetchVendorModules.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVendorModules.fulfilled, (state, action) => {
                state.vendorModules = action.payload;
                state.loading = false;
            })
            .addCase(fetchVendorModules.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(updateModulePrice.fulfilled, (state, action) => {
                const { cat, pricePerMonth } = action.payload;
                const mod = state.modules.find((m) => m.cat === cat);
                if (mod) mod.pricePerMonth = pricePerMonth;
            })
            .addCase(updateModuleStatus.fulfilled, (state, action) => {
                const { cat, status } = action.payload;
                state.modules = state.modules.map(m =>
                    m.cat === cat ? { ...m, status } : m
                );
            });

    },
});

export default moduleSlice.reducer;
